var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"base-dot-icon inline-block w-2 h-2 rounded-full bg-current"})}
var staticRenderFns = []

export { render, staticRenderFns }